import {
  Tile,
  TileImageSection,
  TileInfoSection,
  SkeletonImage,
  SkeletonTextSmall,
  SkeletonTextMedium
} from './VehicleTile.styles';

export default function VehicleTileSkeleton() {
  return (
    <Tile className="h-[314px] animate-pulse sm:h-[269px] md:h-[314px]">
      <TileImageSection>
        <SkeletonImage />
      </TileImageSection>
      <TileInfoSection>
        <div className="flex flex-col gap-4">
          <SkeletonTextSmall className="max-w-[200px]" />
          <SkeletonTextSmall className="max-w-[200px]" />
          <SkeletonTextSmall className="max-w-[160px]" />
        </div>
        <SkeletonTextMedium className="mt-12 max-w-[100px]" />
      </TileInfoSection>
    </Tile>
  );
}
